<template lang="pug">
.cp-logo-wall
  .w
    .content-wrap
      .title 携手去电，筑梦成功
      //- .btn-wrap
      //-   a.btn(@click="showModal") 免费注册
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  methods: {
    showModal () {
      this.$emit('showModal', true)
    }
  }
}
</script>
<style lang="stylus">
.cp-logo-wall
  margin-bottom 80px
  background url('../../../assets/logo-wall.png') center / 1920px no-repeat
  .w
    height 800px
    display flex
    justify-content center
    align-items center
    .btn-wrap
      margin-top 40px
      display flex
      justify-content center
      a
        display block
        width 166px
        height 50px
        line-height 45px
        text-align center
        font-size 20px
        color #fff
        background rgba(255,255,255,0.1)
        box-shadow 0px 2px 4px 0px rgba(255,255,255,0.09)
        border-radius 5px
        border 2px solid rgba(255,255,255,1)
        cursor pointer
        transition all .3s
        &:hover
          background rgba(255,255,255,.4)
</style>
